import * as yup from 'yup'
import moment from 'moment-timezone'

const transcriptFormValidationSchema = yup
  .object({
    timezone: yup.string().oneOf(moment.tz.names())
  })
  .required()

export default transcriptFormValidationSchema
